import { BaseService } from './base.service';
import { CustomTrainingField, CreateFieldRequest, UpdateFieldRequest } from '../models/training.models';

export default class CustomTrainingFieldsService extends BaseService {
  public async listFields(teamId: string) {
    return this.axios.get<{ status: number; message: string; data: CustomTrainingField[] }>(
      `${this.backendUrl}/teams/${teamId}/custom-training-fields`
    );
  }

  public async getField(teamId: string, fieldId: number) {
    return this.axios.get<{ status: number; message: string; data: CustomTrainingField }>(
      `${this.backendUrl}/teams/${teamId}/custom-training-fields/${fieldId}`
    );
  }

  public async createField(teamId: string, data: CreateFieldRequest) {
    return this.axios.post<{ status: number; message: string; data: CustomTrainingField }>(
      `${this.backendUrl}/teams/${teamId}/custom-training-fields`,
      data
    );
  }

  public async updateField(teamId: string, fieldId: number, data: UpdateFieldRequest) {
    return this.axios.patch<{ status: number; message: string; data: CustomTrainingField }>(
      `${this.backendUrl}/teams/${teamId}/custom-training-fields/${fieldId}`,
      data
    );
  }

  public async deleteField(teamId: string, fieldId: number) {
    return this.axios.delete<{ status: number; message: string; data: CustomTrainingField }>(
      `${this.backendUrl}/teams/${teamId}/custom-training-fields/${fieldId}`
    );
  }
}
